import { render, staticRenderFns } from "./AuditPendenciesUp.vue?vue&type=template&id=58e6ff72"
import script from "./AuditPendenciesUp.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports